/**
 * Indicates pro setup should be pre-checked when included in the url for a dynamic package PDP.
 * Should be replaced w/ a shared atom when QuizRecommendedSystem is migrated off legacy site.
 */
export const proSetupQueryParam = 'proSetup'
